const getRandomPos = () => {
    return Math.floor(Math.random() * 90) + 1
}

export default getRandomPos